import { render, staticRenderFns } from "./uncompleteOrder.vue?vue&type=template&id=52f9b912&scoped=true&"
import script from "./uncompleteOrder.vue?vue&type=script&lang=js&"
export * from "./uncompleteOrder.vue?vue&type=script&lang=js&"
import style0 from "./uncompleteOrder.vue?vue&type=style&index=0&id=52f9b912&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f9b912",
  null
  
)

export default component.exports